export enum ImageSourceEnum {
    NORMAL = 'NORMAL',
    AUTOMATE = 'AUTOMATE'
}
